import styled from 'styled-components';

import variables from '../../common/variables';

export const ActionButtons = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  transition: all 0.2s ease-in-out;
  opacity: 0;
`;

export const MainContainer = styled.div`
  position: fixed;
  justify-content: center;
  align-items: center;
  width: ${props => (props.size === 'big' ? '260px' : '160px')};
  height: ${props => (props.size === 'big' ? '260px' : '160px')};
  opacity: ${props => (props.visible ? 1 : 0)};
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  transition: ${props => (props.dragging ? 'none' : 'all 0.2s ease-in-out')};

  &:hover ${ActionButtons} {
    opacity: 1;
  }
`;

export const VideoContainer = styled.div`
  position: fixed;
  left: 30px;
  top: 30px;
  width: calc(100% - 60px);
  height: calc(100% - 60px);
  border-radius: 50%;
  overflow: hidden;
  background-color: ${variables.colors.black};
  background-image: ${props => props.backgroundImage || 'none'};
  background-size: cover;
`;

export const Controller = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: ${props => props.initialOpacity || 0};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

const ControllerButton = styled.i`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  color: ${variables.colors.white};
  font-size: ${props => (props.size === 'big' ? '150px' : '75px')};
  line-height: ${props => (props.size === 'big' ? '200px' : '100px')};
  text-align: center;
  transition: all 0.2s ease-in-out;
`;

export const Play = styled(ControllerButton).attrs({
  className: 'icon-play_icn',
})``;

export const Pause = styled(ControllerButton).attrs({
  className: 'icon-pause',
})``;

export const Record = styled(ControllerButton).attrs({
  className: 'icon-record-vox',
})``;

export const RecordIcon = styled.div`
  display: inline-block;
  width: ${props => props.size * 0.28}px;
  height: ${props => props.size * 0.28}px;
  margin: ${props => props.size * 0.36}px;
  border-radius: 50%;
  background-color: ${variables.colors.red};
  transition: all 0.2s ease-in-out;
`;

export const RecordStopIcon = styled(RecordIcon)`
  border-radius: 0;
`;

export const ActionButton = styled.div`
  position: absolute;
  direction: ${props => (props.right ? 'rtl' : 'ltr')};
  left: ${props => (props.left ? `${props.left}px` : 'auto')};
  right: ${props => (props.right ? `${props.right}px` : 'auto')};
  bottom: ${props => props.bottom}px;
  margin-left: ${props => (props.left ? `${props.size / -2 + 30}px` : 'auto')};
  margin-right: ${props =>
    props.right ? `${props.size / -2 + 30}px` : 'auto'};
  margin-bottom: ${props => props.size / -2 + 30}px;
  height: ${props => props.size}px;
  line-height: ${props => props.size}px;
  max-width: ${props => props.size}px;
  color: ${props =>
    props.color ? variables.colors[props.color] : variables.colors.white};
  background-color: ${props =>
    props.backgroundColor
      ? variables.colors[props.backgroundColor]
      : 'var(--primaryColor)'};
  font-family: Roboto, sans-serif;
  font-size: ${props => props.size * 0.36}px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 0;
  border-radius: ${props => props.size / 2}px;
  white-space: nowrap;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
  cursor: ${props => props.cursor || 'pointer'};
  overflow: hidden;
  white-space: nowrap;
  & > i {
    display: inline-block;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    font-size: ${props => props.size * 0.72}px;
    line-height: ${props => props.size}px;
    text-align: center;
  }
  & > span {
    display: inline-block;
    padding: ${props =>
      props.right ? `0 0 0 ${props.size / 2}px` : `0 ${props.size / 2}px 0 0`};
    vertical-align: top;
  }
  &:hover {
    max-width: 200px;
    color: ${props =>
      props.hoverColor
        ? variables.colors[props.hoverColor]
        : variables.colors.white};
    background-color: ${props =>
      props.backgroundHoverColor
        ? variables.colors[props.backgroundHoverColor]
        : variables.colors.highlightBlue};
  }
`;

export const Loading = styled.div`
  position: absolute;
  left: 30px;
  top: 30px;
  width: calc(100% - 60px);
  height: calc(100% - 60px);
  border-radius: 50%;
  color: ${variables.colors.white};
  background-color: ${variables.colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CircularProgressbarContainer = styled.div`
  position: fixed;
  left: 25px;
  top: 25px;
  width: calc(100% - 50px);
  height: calc(100% - 50px);
  background: ${props => (props.border ? variables.colors.white : 'none')};
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
`;
